module.exports = __webpack_public_path__ + "static/media/solarIcon.c0ed985d.svg";